import { Component, Injector, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import { Observable, combineLatest, map } from 'rxjs';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import {
  realEstatePropertyTypeOptions,
  realestateAgeTypeOptions,
} from '@app/forms/subscription/services/ref';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  PledgeRead,
  Product,
} from '@app/forms/subscription/definition/interface/Pledge';
import { AttributionDao } from '@app/dao/attribution/attribution.dao';
import { lmnpFiscalLawSelectOptions } from '../lmnp-fiscal-law-options';

@UntilDestroy()
@Component({
    selector: 'real-estate-characteristics',
    templateUrl: './real-estate-characteristics.component.html',
    styleUrls: ['./real-estate-characteristics.component.scss'],
    standalone: false
})
export class RealEstateCharacteristicsComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  countries$: Observable<any[]>;
  departments: any[];
  product: Product;
  sessionConsultant: boolean;
  pledge: PledgeRead;

  realEstatePropertyTypeOptions = realEstatePropertyTypeOptions;
  realestateAgeTypeOptions = realestateAgeTypeOptions;
  realEstateTypeOptions = [
    { id: 'UNFURNISHED', value: 'Résidence locative location nue' },
    { id: 'LMNP', value: 'Résidence locative meublée' },
  ];
  fiscalityLawTypeLmnpLmpOptions = lmnpFiscalLawSelectOptions;
  fiscalityLawTypeUnfurnishedOptions = [
    { id: 'FONCIER', value: 'Foncier' },
    { id: 'DEFICITE_FONCIER', value: 'Deficit foncier' },
    { id: 'MICRO_FONCIER', value: 'Micro-foncier' },
    { id: 'PINEL', value: 'Pinel' },
    { id: 'PINEL_DOMTOM', value: 'Pinel DomTom' },
    { id: 'DUFLOT', value: 'Duflot' },
    { id: 'SCELLIER', value: 'Scellier' },
    { id: 'ROBIEN', value: 'Robien' },
    { id: 'BORLOO', value: 'Borloo' },
    { id: 'MONUMENT_HISTO', value: 'Monument historique' },
    { id: 'MALRAUX', value: 'Malraux ZPPAUP' },
    { id: 'MALRAUX_SECTEUR_SAUVE', value: 'Malraux secteur sauvegardé' },
  ];
  fiscalityLawTypeOptions = [];
  constructor(
    protected formConstructor: PrFormConstructor,
    private referenceDao: ReferenceDao,
    private attributionDao: AttributionDao,

    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.fiscalityLawTypeOptions =
      this.subscriptionFacade.getPledge()?.products?.[0].parameters
        .realEstateType === 'LMNP'
        ? this.fiscalityLawTypeLmnpLmpOptions
        : this.fiscalityLawTypeUnfurnishedOptions;
    this.pledge = this.subscriptionFacade.getPledge();
    this.sessionConsultant =
      !!this.pledge && !!this.subscriptionFacade?.getUser()?.sessionConsultant;
    this.countries$ = this.referenceDao.getCountries().pipe(
      untilDestroyed(this),
      map(countries => {
        return countries;
      }),
    );

    this.subscriptionFacade.initForm(this, {
      sessionConsultant: this.sessionConsultant,
    });
  }

  changeFiscalityLawTypeOptions(option) {
    this.fiscalityLawTypeOptions =
      option === 'LMNP'
        ? this.fiscalityLawTypeLmnpLmpOptions
        : this.fiscalityLawTypeUnfurnishedOptions;
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }
  next() {}

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
